/* eslint-disable prefer-const */
/* eslint-disable eqeqeq */
/* eslint-disable no-unused-vars */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable no-prototype-builtins */
/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable prefer-destructuring */
/* eslint-disable array-callback-return */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-nested-ternary */
/* eslint-disable camelcase */
/* eslint-disable no-underscore-dangle */
/* eslint-disable no-dupe-keys */
/* eslint-disable react/jsx-curly-brace-presence */
/* eslint-disable react/no-array-index-key */
/* eslint-disable arrow-body-style */
/* eslint-disable object-shorthand */
/* eslint-disable no-constant-condition */

import React, { Fragment, useEffect,useRef } from "react";
import { connect, useDispatch, useSelector } from "react-redux";
import MaterialTable from "material-table";
import { useHistory, useLocation } from "react-router-dom";
import axios from "axios";
import clsx from "clsx";
import moment from 'moment';
import Grid from "@material-ui/core/Grid";
import FormControlLabel from "@mui/material/FormControlLabel";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import Select from "react-select";
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { InputText } from 'primereact/inputtext';
import { FilterMatchMode, FilterOperator } from 'primereact/api';
import { CustomDatePicker, ValidatingTextField } from "../FormComponents"; // Added this for CHG0073013
import tableIcons from "./MaterialTableIcons";
import { Button } from "../../atomicComponents";
import styles from "./LinkageDashboardForm.module.css";
import { MESSAGE_TYPE } from "../../constants";
import { usePopupManager } from "../../providers/PopupManager/PopupManager";
import MultiSelect from "../FormComponents/MultiSelect";
import Truckloading from "../CvLoader/Cvloader";
import { setLogin } from "../../redux/features/auth/actions";
import { sanitizeNumeric } from "../../utils/utils";
import TableSimple from "../../atomicComponents/TableSimple1/TableSimple"; // Added this for CHG0073013
import CustomPagination from "../CustomPagination/CustomPagination"; // Added this for CHG0073013
import apiService from "../../apis/apiService"; // Added this for CHG0073013


// import { DataGrid } from "@material-ui/data-grid";

function LinkageDashboardForm() {
  const history = useHistory();
  const location = useLocation();

  const { useState } = React;
  const [selected, setSelected] = useState(0);
  const [, setselectedData] = useState(null);
  const { showPopup } = usePopupManager();
  const baseUrl = useSelector((state) => state.counter.baseUrl); // useSelector
  const auth = useSelector((state) => state.auth); // useSelector
  const [saveData, setSaveData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]); // Added this for CHG0073013
  const [page, setPage] = useState(1); // Added this for CHG0073013
  const [pageSize, setPageSize] = useState(10); // Added this for CHG0073013
  const [mobile, setMobile] = useState(window.innerWidth <= 500);
  const { personNumber, userRole, userName, apiSendData } = auth;
 
  const dispatch = useDispatch();
  const data = location.state?.data;
  const stateData = apiSendData == undefined ? data : apiSendData;

  const URole = userRole.includes("U");
  const LIRole = userRole.includes("LI");
  const SARole = userRole.includes("SA");
  const BRole = userRole.includes("B");

  const handleWindowSizeChange = () => {
    setMobile(window.innerWidth <= 500);
  };

  useEffect(() => {
    window.addEventListener("resize", handleWindowSizeChange);
    return () => {
      window.removeEventListener("resize", handleWindowSizeChange);
    };
  }, []);

  const options2 = [
    { label: "In Progress", value: null },
    { label: "Approved", value: "C" },
    { label: "Rejected", value: "R" },
    // Add more options as needed
  ];

  const [reqType, setReqType] = useState("");
  const [reqStatus, setReqStatus] = useState("");
  const [displayView, setDisplayView] = useState(true);
  const [disable, setDisable] = useState(false);
  const [tableDisplay, setTableDisplay] = useState(false);
  const [monthDiff, setMonthDiff] = useState(0);
  const [apiPayloadData, setAPIPaylodData] = useState(stateData);

   // Get the first day of the current month
  //  const firstDayOfMonth = new Date();
  //  firstDayOfMonth.setDate(1);

   const currentDate = new Date();

  // Calculate the date one month ago
  const oneMonthAgo = new Date(currentDate);
  oneMonthAgo.setMonth(oneMonthAgo.getMonth() - 1);

// const [selectedDate, setSelectedDate] = useState(oneMonthAgo);
  const [selectedDate, setSelectedDate] = useState(moment(oneMonthAgo).format('YYYY-MM-DD'));
  const [selectedToDate, setSelectedToDate] = useState(moment(new Date()).format('YYYY-MM-DD'));
  const [daysDifference, setDaysDifference] = useState(null);
  const [globalFilter, setGlobalFilter] = useState('');
  const [filters, setFilters] = useState(null);
  const [paginatedData, setPaginatedData] = useState([]); // Added this for CHG0073013
  const [spocRemark, setSpocRemark] = useState({}) // Added this for CHG0073013
  const handleFromDateChange = (date) => {
    setSelectedDate(moment(date).format('YYYY-MM-DD'));
    setSaveData([]);
     if(data != undefined && apiPayloadData.start_date == ''){
      setAPIPaylodData({
        ...apiPayloadData,
        start_date: moment(date).format('YYYY-MM-DD'),
        end_date: selectedToDate
      })
    }else {
      setAPIPaylodData({
        ...apiPayloadData,
        start_date: moment(date).format('YYYY-MM-DD'),
        end_date: selectedToDate
      })
    }

  };

  const handleToDateChange = (date) => {
    setSelectedToDate(moment(date).format('YYYY-MM-DD'));
    setSaveData([]);
    if(data != undefined && apiPayloadData.start_date == ''){
      setAPIPaylodData({
        ...apiPayloadData,
        start_date: selectedDate,
        end_date: moment(date).format('YYYY-MM-DD')
      })
    }else{
      setAPIPaylodData({
        ...apiPayloadData,
        start_date: selectedDate,
        end_date: moment(date).format('YYYY-MM-DD')
      })
    }
  };

  const [columns] = useState([
    {
      title: "Sr No",
      field: "SRNo",
      editable: "false",
      cellStyle: {
        fontSize: mobile ? "10px" : "13px",
      },
    },
    {
      title: "Request No",
      field: "RequestNo",
      editable: "false",
      cellStyle: {
        fontSize: mobile ? "10px" : "13px",
      },
      render: (row) => {
        const RequestNoVal = row.RequestNo;
        return (
          <div className="">
            <div>
              <span
                href=""
                onClick={(event) => {
                  event.preventDefault();
                  history.push(`/request-view/PL/${RequestNoVal}`);
                }}
                style={{
                  color: "#608FC9",
                  cursor: "pointer",
                  borderBottom: "1px solid #608FC9",
                }}
              >
                {RequestNoVal}
              </span>
            </div>
          </div>
        );
      },
    },
    {
      title: "Request Type",
      field: "RequestType",
      editable: "false",
      cellStyle: {
        fontSize: mobile ? "10px" : "13px",
      },
    },

    {
      title: "Linkage Spoc",
      field: "Linkage_SPOC",
      editable: "false",
      cellStyle: {
        fontSize: mobile ? "10px" : "13px",
        width: "20%",
      },
      render: (row) => {
        const Status = row.Status == "In Progress" ? "Inprogress" : row.Status;
        return (
          <div className={clsx(styles.Rdetails, styles[Status])}>
            <div>
              {Status === "Inprogress" &&
              (userRole.includes("LI") || userRole.includes("SA")) &&
              row.Linkage_SPOC_No.split(",").includes(personNumber) ? (
                <span
                  href=""
                  onClick={(event) => {
                    event.preventDefault();
                    history.push(`/access-control/PL/${row.RequestNo}`);
                  }}
                  style={{
                    color: "#608FC9",
                    cursor: "pointer",
                    borderBottom: "1px solid #608FC9",
                  }}
                >
                  {row.approval_type === "SA"
                    ? "SBP Team"
                    : row.Linkage_SPOC.split(",").find(
                        (name) => name.trim() === userName.trim()
                      ) || row.Linkage_SPOC}
                </span>
              ) : (
                <span style={{ color: "#608FC9" }}>
                  {row.approval_type === "SA"
                    ? row.approver !== null && row.approver !== ""
                      ? row.approver
                      : "SBP Team"
                    : row.approver !== null
                    ? row.approver
                    : row.Linkage_SPOC.split(",")
                        .map((name) => name.trim())
                        .filter((name) => name !== "") // Filter out empty entries
                        .slice(0, 2)
                        .join(", ")}
                </span>
              )}
            </div>
            <div>
              <span style={{ color: "#608FC9" }}>{row.approvalDate}</span>
            </div>
          </div>
        );
      },
    },

    {
      title: "Status",
      field: "Status",
      editable: "false",
      cellStyle: {
        fontSize: mobile ? "10px" : "13px",
      },
    },
  ]);


  const RequestNoLink = (reqNo, payloadData) => {
    let sendAPIData= payloadData;
    return (
    <div className="">
    <div>
      <span
        href=""
        onClick={(event) => {
          event.preventDefault();
          history.push(`/request-view/PL/${reqNo}`);
          dispatch(setLogin({ ...auth, apiSendData: sendAPIData}));
        }}
        style={{
          color: "#608FC9",
          cursor: "pointer",
          borderBottom: "1px solid #608FC9",
        }}
      >
        {reqNo}
      </span>
    </div>
  </div>
    )
  };

  const linlkageSpocLink = (statusVal,LinkageSPOC_No,RequestNo,approval_type,Linkage_SPOC,approver,approvalDate,modifyBy, payloadData) => {
    const Status = statusVal == "INPROGRESS" ? "Inprogress" : statusVal;

    let linkageSpocArray = Linkage_SPOC === null ||  Linkage_SPOC === "" ? "" : Linkage_SPOC.split(',').map(name => name.trim());

    let linkageSpocNo = LinkageSPOC_No === null ||  LinkageSPOC_No === "" ? "" : LinkageSPOC_No.split(',').map(name => name.trim());

    console.log("Linkage_SPOC--- > ", linkageSpocArray, linkageSpocArray.length);
    let accesscontrolApiPayload= payloadData;

    return (
      <div className={clsx(styles.Rdetails, styles[Status])}>
        <div>
          {Status === "Inprogress" &&
          (userRole.includes("LI") || userRole.includes("SA")) &&
          linkageSpocNo.includes(personNumber) ? (
            <span
              href=""
              onClick={(event) => {
                event.preventDefault();
                history.push(`/access-control/PL/${RequestNo}`);
                dispatch(setLogin({ ...auth, apiSendData: accesscontrolApiPayload}));
              }}
              style={{
                color: "#608FC9",
                cursor: "pointer",
                borderBottom: "1px solid #608FC9",
              }}
            >
              {modifyBy === 'SYSTEM'
                ? "System" : approval_type === "SA" 
                ? "SBP Team" : 
                Linkage_SPOC.split(",")
                .map((name) => name.trim())
                .filter((name) => name !== "") // Filter out empty entries
                .slice(0, 2)
                .join(", ") || Linkage_SPOC }
            </span>
          ) : (
            <span style={{ color: "#608FC9" }}>
              {modifyBy === 'SYSTEM' ? "System" : 
               approval_type === "SA" && linkageSpocArray.length > 1 ? "SBP Team" : 
               approval_type === "SA" && linkageSpocArray.length <=1 ? Linkage_SPOC :
               approval_type === "" && linkageSpocArray.length > 1 ?  linkageSpocArray.map((name, index) => (<div key={index}>{name}</div>)) : Linkage_SPOC
              }
            </span>
          )}
        </div>
        <div>
          <span style={{ color: "#608FC9" }}>{approvalDate}</span>
        </div>
      </div>
    );
  }

  // Function to process data in chunks or pages
  const processData = (tbdata, payloadData) => {
 
      // console.log("API Data: ", data);
      const processedData = tbdata.map((entry, index) => ({
        SRNo: (index + 1).toString(),
        // RequestNo: entry.request_no,
        RequestNo: RequestNoLink(entry.request_no, payloadData),
        RequestNoHide: entry.request_no,
        RequestType: entry.request_type,
        RequesterNo: entry.requestor_pers_no,
        EmployeerName: entry.employee_name,
        // Linkage_SPOC: entry.spoc_linkage_names,
        Linkage_SPOC: linlkageSpocLink(entry.status,entry.spoc_linkage_persnos,entry.request_no,entry.approval_type,entry.spoc_linkage_names,entry.approver_name,entry.admin_approved_date,entry.modified_by, payloadData),
        Linkage_SPOC_No: entry.spoc_linkage_persnos,
        Status: entry.status === "INPROGRESS"
            ? "In Progress"
            : entry.status.charAt(0).toUpperCase() +
              entry.status.slice(1).toLowerCase(),
        approvalDate: entry.admin_approved_date,
        approval_type: entry.approval_type,
        approver: entry.approver_name,
        modifyBy : entry.modified_by,
      }));
  
      return processedData;
    };
// Change Start for CHG0073013 
  const loginPerson = auth?.personNumber;
  const spocLinkagePersnos = saveData?.map((entry) => entry.spoc_linkage_persnos).join(',');
  
  const isSame = spocLinkagePersnos
    .split(",")
    .map(x => x.trim())
    .includes(loginPerson);
// Change End for CHG0073013
  const onClickSubmitBtn = () => {

    // const apiFormatedData = {
    //   user_id: personNumber,
    //   req_type: reqType,
    //   request_status: reqStatus.value,
    //   start_date: selectedDate,
    //   end_date: selectedToDate,
    // };

    let apiFormatedData = {};
    if (reqType != "" && reqStatus != "") {
      apiFormatedData = {
        user_id: sanitizeNumeric(personNumber),
        req_type: reqType,
        request_status: reqStatus?.value,
        start_date: selectedDate,
        end_date: selectedToDate,
      };
    } else if (reqType == "" && reqStatus == "") {
      if (SARole || BRole || LIRole) {
        apiFormatedData = {
          user_id: sanitizeNumeric(personNumber),
          req_type: "approval",
          request_status: null,
          start_date: selectedDate,
          end_date: selectedToDate,
        };
        setReqType("approval");
        setReqStatus({ label: "In Progress", value: null });
        setDisplayView(true);
      } else {
        apiFormatedData = {
          user_id: sanitizeNumeric(personNumber),
          req_type: "created",
          request_status: null,
          start_date: selectedDate,
          end_date: selectedToDate,
        };
        setReqType("created");
        setReqStatus({ label: "In Progress", value: null });
        setDisplayView(false);
      }
    } else {
      apiFormatedData = {
        user_id: sanitizeNumeric(personNumber),
        req_type: "approval",
        request_status: null,
        start_date: selectedDate,
        end_date: selectedToDate,
    };
      setReqType("approval");
      setReqStatus({ label: "In Progress", value: null });
      setDisplayView(false);
    }

    setLoading(true);

    // console.log("state api data: ", apiPayloadData);

    let apiFormatedData_updated = {};

    if(data != undefined && apiPayloadData.start_date == ''){
      apiFormatedData_updated = ({...apiPayloadData, start_date: selectedDate, end_date: selectedToDate});
      apiFormatedData = apiFormatedData_updated;
      // console.log("inner state api data: ", apiFormatedData);
      setReqType(apiPayloadData.req_type);
      setReqStatus(apiPayloadData.request_status == null ? { label: "In Progress", value: null } : reqStatus);
    }
    else if(apiSendData != undefined){
      if(apiSendData.start_date == ""){
        apiFormatedData = ({...apiPayloadData, start_date: selectedDate, end_date: selectedToDate});
      }else{
        apiFormatedData = apiPayloadData;
      }

      // console.log("Req api data: ", apiFormatedData);
      setReqType(apiFormatedData.req_type);
      setReqStatus(apiFormatedData.request_status == null ? { label: "In Progress", value: null } :
      apiPayloadData.request_status == 'C' ? { label: "Approved", value: "C" } :
      apiPayloadData.request_status == 'R' ? { label: "Rejected", value: "R" } : reqStatus);
      setSelectedDate(apiFormatedData.start_date);
      setSelectedToDate(apiFormatedData.end_date);
    }

    // console.log("final api data: ", apiFormatedData);

    const apiFormatedDataJson = JSON.stringify(apiFormatedData);
    const headerss = new Headers();
    headerss.append("Content-Type", "application/json");
    fetch(`${baseUrl}master/ProjectLinkageDashboardNew`, {
      method: "POST",
      headers: headerss,
      credentials:'include',
      body: apiFormatedDataJson,
    })
      .then((response) => {
        dispatch(setLogin({ ...auth, recentStatus: response.status }));
        if (response.status === 403) {
          dispatch(setLogin({ ...auth, recentStatus: response.status }));
        }
        return response.json();
      })
      .then((responseJSON) => {
        // console.log("daysDifference----------> ", daysDiffaerence);

        if (responseJSON.msg === "Success") {
          // setSaveData([]);
          setLoading(false);
          setSpocRemark({}) // Added this for CHG0073013
          setSelectedRows([]) // Added this for CHG0073013
          if(monthDiff <=2){
          if (responseJSON.data.length >= 1) {
            setSaveData([]);
            const processedData = processData(responseJSON.data, apiFormatedData);
            setSaveData(responseJSON.data); // Added this for CHG0073013
            setTableDisplay(true);

          } else {
            setTableDisplay(false);
            setSaveData([]);
            showPopup({
              type: MESSAGE_TYPE.INFORMATION,
              contextText: MESSAGE_TYPE.INFORMATION,
              info: "Data Not Found",
            });

            setTableDisplay(false);
          }
          }
        } else if (responseJSON.msg === "Info") {
          setLoading(false);
          setTableDisplay(false);
          setSaveData([]);
          if (responseJSON.data != "User Logged In On another Screen") {

            if (daysDifference === null || daysDifference < 0) {
              setLoading(false);
              setTableDisplay(false);
              setSaveData([]);
              showPopup({
                type: MESSAGE_TYPE.INFORMATION,
                contextText: MESSAGE_TYPE.INFORMATION,
                info: "To date should not be less than From date",
              });
            }else{
              showPopup({
                type: MESSAGE_TYPE.INFORMATION,
                contextText: MESSAGE_TYPE.INFORMATION,
                // info: "Oops! The selected dates should be within a range of 60 days or less",
                info: "Report can be fetched maximum for two months"
                // info: response.data
              });
            }
          }
        } else if (responseJSON.msg === "Fail") {
          setLoading(false);
          showPopup({
            type: MESSAGE_TYPE.FAILURE,
            contextText: MESSAGE_TYPE.FAILURE,
            info: "Oops! Something went wrong. Please try again later",
          });
        }
      })
      .catch((error) => {
        // console.log("error---------->", error)
        showPopup({
          type: MESSAGE_TYPE.INFORMATION,
          contextText: MESSAGE_TYPE.INFORMATION,
          info: "Something Went wrong.",
        });
      });
  };

  const baseDefaultColumns = [
    {
      width: 50,
      textAlign: 'center',
      title: 'SR No',
      field: 'SRNo',
      enableSearch: true,
      enableFilter: true,
    },
    {
      width: 120,
      textAlign: 'center',
      title: 'Request No',
      field: 'RequestNo',
      enableSearch: true,
      enableFilter: true,
    },
    {
      width: 150,
      textAlign: 'center',
      title: 'Request Type',
      field: 'RequestType',
      enableSearch: true,
      enableFilter: true,
    },
    {
      width: 200,
      textAlign: 'center',
      title: 'Employee Name',
      field: 'EmployeerName',
      enableSearch: true,
      enableFilter: true,
    },
    {
      width: 0,
      title: '',
      field: 'RequestNoHide',
      enableSearch: true,
      enableFilter: true,
    },
    {
      width: 200,
      title: 'Linkage SPOC',
      field: 'Linkage_SPOC',
      enableSearch: true,
      enableFilter: true,
    },
    {
      width: 150,
      textAlign: 'center',
      title: 'Status',
      field: 'Status',
      enableSearch: true,
      enableFilter: true,
    }
  ];

  const initFilters = () => {
    const initialFilters = {global: { value: null, matchMode: FilterMatchMode.CONTAINS }};
    baseDefaultColumns.forEach((column) => { 
      initialFilters[column.field] ={ value: null, matchMode: FilterMatchMode.CONTAINS };
    });
    setFilters(initialFilters);
  };
  useEffect(() => {
    initFilters();
  }, []);

  const clearFilter = () => {
    initFilters();
  };
  const filteredData = saveData?.filter((item) => {
    const searchValue = globalFilter?.toLowerCase().trim();
  
    if (!searchValue) return true;
  
    const projectDetails = `${item.project_details?.[0]?.project_def || ""} - ${
      item.project_details?.[0]?.project_desc || ""
    }`;
  
    return (
      item.request_no?.toString().toLowerCase().includes(searchValue) ||
      item.request_type?.toLowerCase().includes(searchValue) ||
      item.employee_name?.toLowerCase().includes(searchValue) ||
      projectDetails.toLowerCase().includes(searchValue) ||
      moment(item.project_details?.[0]?.start_date || "")
        .format("DD-MM-YYYY")
        .toLowerCase()
        .includes(searchValue) ||
      moment(item.project_details?.[0]?.end_date || "")
        .format("DD-MM-YYYY")
        .toLowerCase()
        .includes(searchValue) ||
      item.project_details?.[0]?.user_remark
        ?.toLowerCase()
        .includes(searchValue) ||
      item.spoc_linkage_names?.toLowerCase().includes(searchValue)
    );
  });
  const paginatedFilteredData = filteredData.slice(
    (page - 1) * pageSize,
    page * pageSize
  );  
  const onGlobalFilterChange = (e) => {
    const {value} = e.target;
    const _filters = { ...filters };

    _filters.global.value = value;

    setFilters(_filters);
    setGlobalFilter(value);
    setPage(1); // Reset to first page when filter changes
};

  useEffect(() => {
    onClickSubmitBtn();
  }, []);
// Start CHG0073013
  useEffect(() => {
    const startIndex = (page - 1) * pageSize;
    const endIndex = startIndex + pageSize;
    setPaginatedData(saveData?.slice(startIndex, endIndex) || []);
    }, [saveData, page, pageSize]);
  // END CHG0073013
  const handleChange1 = (event) => {
    setReqType(event.target.value);
    setSaveData([]);
    if(data != undefined && apiPayloadData.start_date == ''){
      setAPIPaylodData({
        user_id: personNumber,
        req_type: event.target.value,
        request_status: reqStatus.value
      })
    }else{
      setAPIPaylodData({
        user_id: personNumber,
        req_type: event.target.value,
        request_status: reqStatus.value,
        start_date: selectedDate,
        end_date: selectedToDate
      })
    }
    
  };

  const handleChange2 = (selectedOptions2) => {
    setReqStatus(selectedOptions2);
    setSaveData([]);
    if(data != undefined && apiPayloadData.start_date == ''){
        setAPIPaylodData({
          user_id: personNumber,
          req_type: reqType,
        request_status: selectedOptions2.value,
        })
      }else{
        setAPIPaylodData({
          user_id: personNumber,
          req_type: reqType,
          request_status: selectedOptions2.value,
          start_date: selectedDate,
          end_date: selectedToDate
        })
      }
  };

  const handleClose = () => {
    setReqType("");
    setReqStatus("");
    // setDisable(true);
  };
// Changes Start for CHG0073013
  const handleCheckboxChange = (event, item) => {
    if (event.target.checked) {
      setSelectedRows(prev => [
        ...prev,
        {
          ...item,
          linkage_spoc_remark: item.spoc_remark || "",
        },
      ]);
    } else {
      setSelectedRows(prev =>
        prev.filter(row => row.request_no !== item.request_no)
      );
    }
  };
  
  const handleSpocRemarkChange = (value, requestNo) => {
    setSpocRemark(prev => ({
      ...prev,
      [requestNo]: value,
    }));
  
    setSelectedRows(prev =>
      prev.map(row =>
        row.request_no === requestNo
          ? {
              ...row,
              linkage_spoc_remark: value,
            }
          : row
      )
    );
  };
// Changes END for CHG0073013
 useEffect(() => {
  if (selectedDate && selectedToDate) {
    const startDate = new Date(selectedDate);
    const endDate = new Date(selectedToDate);
    
    const startYear = startDate.getFullYear();
    const endYear = endDate.getFullYear();
    const startMonth = startDate.getMonth();
    const endMonth = endDate.getMonth();
    
    const yearDiff = endYear - startYear;
    // Convert difference to Months
    const monthDifference = endMonth - startMonth + (yearDiff * 12);
    setMonthDiff(monthDifference);

    const startMs = startDate.getTime();
    const endMs = endDate.getTime();
    // Calculate difference in milliseconds
    const differenceInMs = endMs - startMs;
    // Convert difference to days
    const differenceInDays = differenceInMs / (1000 * 60 * 60 * 24);
    setDaysDifference(differenceInDays);
  }
},[selectedDate,selectedToDate]);

  const DateGroup = () => (
    <div>
      <Grid
        container
        spacing={1}
        style={{ display: "flex", justifyContent: "left" }}
        columns={12}
      >
        <Grid item md={6} lg={6}>
        <div style={{marginLeft: '-10px', width: '110%', display: "flex" }}>
            <div className={clsx(styles.lableDiv)}>
              <label>From Date: </label>
            </div>
            <div className={styles.formDiv}>
              <CustomDatePicker
                clearable
                autoOk
                inputVariant="outlined"
                inputProps={{
                  className: clsx(styles.select, styles.dateInput),
                }}
                emptyLabel="DD-MM-YYYY"
                format="DD-MM-YYYY"
                value={selectedDate}
                onChange={handleFromDateChange}
                data-testid="date-picker-div-1"
                style={{ width: "50%" }}
              />
            </div>
          </div>
        </Grid>
        <Grid item md={5} lg={5}>
          <div style={{ marginLeft: "-35%", display: "flex" }}>
            <div className={clsx(styles.lableDiv)}>
              <label>To Date: </label>
            </div>
            <div className={styles.formDiv}>
              <CustomDatePicker
                clearable
                autoOk
                inputVariant="outlined"
                value={selectedToDate}
                onChange={handleToDateChange}
                inputProps={{
                  className: clsx(styles.select, styles.dateInput),
                }}
                emptyLabel="DD-MM-YYYY"
                format="DD-MM-YYYY"
                style={{ width: "50%", marginLeft: "-5%"}}
              />
            </div>
          </div>
        </Grid>
        <Grid item md={1} lg={1}>
          <div style={{ marginLeft: "-110px", width: "100%", display: "flex" }}>
            <div className={styles.formDiv}>
              <Button
                className={clsx(
                  styles.actionButton,
                  styles.primaryActionButton
                )}
                variant="primary"
                // disabled={disable}
                onClick={() => onClickSubmitBtn()}
                // onClick={() => onClickSubmitNew()}
                data-testid="confirm-action"
              >
                SUBMIT
              </Button>
              {/* <Button
                  className={clsx(styles.actionButton, styles.resetButton)}
                  variant="tertiary"
                  onClick={handleClose}
                  style={{marginLeft: "10px"}}
                >
                  CANCEL
                </Button> */}
            </div>
          </div>
        </Grid>
      </Grid>
    </div>
  );

  // const justifyContent = displayView ? "initial" : "center";
  const gridItem = displayView ? 6 : 12;

  const MyRequestView = () => (
    <Grid container spacing={1} columns={12}>
      <Grid item md={gridItem} lg={gridItem} sm={12} xs={12}>
        <RadioGroup
          row
          aria-labelledby="demo-row-radio-buttons-group-label"
          name="row-radio-buttons-group"
          label="role1"
          value={reqType}
          onChange={handleChange1}
        >
          <FormControlLabel
            value="created"
            name="role1"
            control={<Radio size="small" />}
            label="My Request (Raised by me)"
            style={{ color: "black" }}
            className={styles.radiobtn}
          />
        </RadioGroup>
      </Grid>
      {displayView ? (
        <Grid item md={6} lg={6} sm={12} xs={12}>
          <RadioGroup
            row
            aria-labelledby="demo-row-radio-buttons-group-label"
            name="row-radio-buttons-group"
            value={reqType}
            onChange={handleChange1}
            style={{ marginLeft: "-20px" }}
          >
            <FormControlLabel
              value="approval"
              name="role2"
              control={<Radio size="small" />}
              label="My Approval (Pending on me)"
              style={{ color: "black" }}
              className={styles.radiobtn}
            />
          </RadioGroup>
        </Grid>
      ) : (
        ""
      )}
    </Grid>
  );

  const selectGroup = () => (
    <div>
      <Grid
        container
        spacing={1}
        style={{ display: "flex", justifyContent: "left" }}
        columns={12}
      >
        <Grid item md={7} lg={7}>
          {MyRequestView()}
        </Grid>
        <Grid item md={5} lg={5}>
          <div className={styles.rowDiv} style={{ marginLeft: "-18%" }}>
            <div className={clsx(styles.lableDiv)}>
              <label>Status: </label>
            </div>
            <div className={styles.formDiv} style={{ marginRight: "-10%" }}>
              <Select
                className={clsx(styles.select, styles.sel2)}
                options={options2}
                value={reqStatus}
                onChange={handleChange2}
                name="Status"
                // menuIsOpen={true}
                styles={{
                  menu: (styles1) => ({ ...styles1, zIndex: 24 }),
                  menuList: (provided) => ({
                    ...provided,
                    // fontSize:isMobileDevice ? "10px" : "14px",
                    zIndex: 24,
                    "&::-webkit-scrollbar": {
                      width: "4px !important",
                      height: "6px",
                      display: "block !important",
                      background: "none",
                    },
                    "&::-webkit-scrollbar-track": {
                      background: "none",
                    },
                    "&::-webkit-scrollbar-thumb": {
                      background: "#f17c7c",
                    },
                    "&::-webkit-scrollbar-thumb:hover": {
                      background: "#da6363",
                    },
                  }),
                }}
              />
            </div>
          </div>
        </Grid>
      </Grid>
    </div>
  );

  const RadioGroupRole = () => (
    <Grid
      container
      spacing={0}
      style={{ marginTop: "10px" }}
      // className={styles.myGrid}
      columns={12}
    >
      <Grid item md={6} lg={6} sm={12} xs={12}>
        {selectGroup()}
      </Grid>
      <Grid item md={6} lg={6} sm={12} xs={12}>
        {DateGroup()}
      </Grid>
    </Grid>
  );

  const CustomTitle = () => (
    <div style={{ marginTop: "10px" }}>
      <Grid container columns={12} className={styles.myGrid}>
        <Grid item md={12} lg={12} sm={12}>
          <div className={styles.rowDiv_circle}>
            <div className={styles.formDiv}>
              <div
                className={styles.circle}
                style={{ backgroundColor: "rgba(130, 193, 167)" }}
              >
                {" "}
              </div>
              <div className={styles.lableMaster}>
                <span className={styles.title2}>Request Approved</span>
              </div>
            </div>
            <div className={styles.formDiv}>
              <div
                className={styles.circle}
                style={{ backgroundColor: "#f42323" }}
              >
                {" "}
              </div>
              <div className={styles.lableMaster}>
                <span className={styles.title2}>Request Rejected</span>
              </div>
            </div>
            <div className={styles.formDiv}>
              <div
                className={styles.circle}
                style={{ backgroundColor: "#FFA222" }}
              >
                {" "}
              </div>
              <div className={styles.lableMaster}>
                <span className={styles.title2}>Request In Progress</span>
              </div>
            </div>
          </div>
        </Grid>
      </Grid>
    </div>
  );
// Changes Start for CHG0073013
const previousLength = useRef(selectedRows.length);

useEffect(() => {
  if (previousLength.current <= 10 && selectedRows.length > 10) {
    showPopup({
      type: MESSAGE_TYPE.INFORMATION,
      contextText: MESSAGE_TYPE.INFORMATION,
      info: "You can select a maximum of 10 requests at a time.",
    });
  }

  previousLength.current = selectedRows.length;
}, [selectedRows]);

  const handleApproveReject = async(flag) => {
      let apiFormatedData = selectedRows.map((item) => ({
        request_id: item?.request_no || '',
        spoc_flag: flag,
        user_id: auth.personNumber,
        linkage_spoc_remark: spocRemark[item.request_no] || "",
        effective_date: item?.project_details?.[0]?.start_date,
        end_date: item?.project_details?.[0]?.end_date,
        pl_hours: item.pl_hours || '',
        proj_def: item?.project_details?.[0]?.project_def,
        project_desc: item?.project_details?.[0]?.project_desc,
        user_remark: item?.project_details?.[0]?.user_remark,
        request_type: item.request_type,
      }))
      if(selectedRows?.length > 10){
        showPopup({
          type: MESSAGE_TYPE.INFORMATION,
          contextText: MESSAGE_TYPE.INFORMATION,
          info: "You can select a maximum of 10 requests at a time.",
        });
        return;
      } 
      // if(selectedRows?.length < 0){
      //   showPopup({
      //     type: MESSAGE_TYPE.INFORMATION,
      //     contextText: MESSAGE_TYPE.INFORMATION,
      //     info: "Please select at least one project to Approve/Reject",
      //   });
      //   return ;
      // }
          setLoading(true)
           try {
            
            
            const response = await apiService.ProjectLinkageApprove(apiFormatedData,dispatch)
            dispatch(setLogin({...auth, recentStatus: response.status}))
            if (response?.data) {
              setLoading(false)
               if (response.msg=="Success") {
                setLoading(false)           
                 let MSG = "";
                 if (flag === "A") {
                   MSG = `Request approved for :${selectedRows.map((item) => item.request_no).join(", ")}`;
                   showPopup({
                     type: MESSAGE_TYPE.SUCCESS,
                     contextText: MESSAGE_TYPE.SUCCESS,
                     info: MSG,
                     reloads:true
                   });
                 } else if (flag === "R") {
                   MSG = `Request rejected for : ${selectedRows.map((item) => item.request_no).join(", ")}`;
                   showPopup({
                     type: MESSAGE_TYPE.SUCCESS,
                     contextText: MESSAGE_TYPE.SUCCESS,
                     info: MSG,
                     reloads:true
                   });
                 }
                //  setApproveFlag(flag);
               }
               else if(response.msg=="Fail"){
                setLoading(false)
                showPopup({
                  type: MESSAGE_TYPE.FAILURE,
                  contextText: MESSAGE_TYPE.FAILURE,
                  info: response.data || "Oops! Something went wrong. Please try again later",
                });
               }
             }
           } catch (error) {
            setLoading(false)
               console.info(error);
               showPopup({
                 type: MESSAGE_TYPE.INFORMATION,
                 contextText: MESSAGE_TYPE.INFORMATION,
                 info: "Oops! Something went wrong. Please try again later",
               });
           }finally{
            setLoading(false)
           }                 
         
};
const handleSelectAll = event => {
  const { checked } = event.target;
  if (checked) {
    setSelectedRows([...paginatedFilteredData]);
  } else {
    setSelectedRows([]);
  }
};

const isAllSelected =
paginatedFilteredData.length > 0 &&
  selectedRows.length === paginatedFilteredData.length;

const isIndeterminate =
  selectedRows.length > 0 &&
  selectedRows.length < paginatedFilteredData.length;
// Changes END for CHG0073013

  const renderReport = () => (
    <div className={styles.formGroup}>
      <div
        style={{
          width: "100%",
          height: "50%",
          marginTop: "10px",
          marginBottom: "10px",
        }}
      >
        <Grid
          container
          style={{
            marginTop: "10px",
            justifyContent: "center",
            margin: "10px",
          }}
          columns={12}
          className={styles.myGrid}
        >
          <Grid item md={12} lg={12} sm={12} xs={12}>
            <div style={{ marginTop: "6px" }}>{RadioGroupRole()}</div>
          </Grid>
          {tableDisplay && saveData.length >= 1 ? (
            <Grid item md={12} lg={12} sm={12}>
              <Grid
                container
                style={{
                  marginTop: "10px",
                  justifyContent: "center",
                  marginTop: "10px",
                }}
                columns={12}
                className={styles.myGrid}
              >
              <Grid item md={9} lg={9} sm={12}>
                {CustomTitle()}
              </Grid>
            <Grid item md={3} lg={3} sm={12}>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                <span className="p-input-icon-left">
                  <i className="pi pi-search"  style={{marginLeft:'5px'}}/> {/* CSS Added for CHG0073013 */}
                  <InputText value={globalFilter} onChange={onGlobalFilterChange} placeholder="Keyword Search" style={{ fontSize: '12px', margin: '3px', paddingLeft:'27px' }} /> {/* Css Added for CHG0073013 */}
                </span>
              </div>
              </Grid>
              </Grid>
            </Grid>
          ) : (
            ""
          )}
        </Grid>

        {loading ? (
          <div
            style={{
              textAlign: "center",
              display: "flex",
              justifyContent: "center",
              marginTop: "40px",
            }}
          >
            <Truckloading />
          </div>
        ) : (
          <>
            {saveData.length >= 1 ? (
              // <MaterialTable
              //   icons={tableIcons}
              //   options={{
              //     paging: true,
              //     actionsColumnIndex: -1,
              //     selection: false,
              //   }}
              //   title=""
              //   columns={columns}
              //   data={saveData}
              // /> 
        // Changes Start for CHG0073013                        
              <>
               <div style={{ position: 'relative', marginTop: '10px' }}>
                
              <TableSimple
                              tableColumnData={paginatedFilteredData?.map((item, index) => ({
                                select: (
                                  <input
                                    type="checkbox"
                                    checked={selectedRows.some(
                                      row => row.request_no === item.request_no
                                    )}
                                    onChange={(event) => handleCheckboxChange(event, item)}
                                    style={{ cursor: "pointer" }}
                                  />

                                ),                         
                                request_no:item.request_no || "",
                                request_type: item.request_type || "",                            
                                employee_name: item.employee_name || "",
                                project_details:`${item.project_details?.[0]?.project_def || ""} - ${item.project_details?.[0]?.project_desc || ""}`,                           
                                start_date: moment(item.project_details?.[0]?.start_date || '').format('DD-MM-YYYY') || "",
                                end_date: moment(item.project_details?.[0]?.end_date || "").format('DD-MM-YYYY') ,
                                user_remark: (
                                  <div className="user-remark-cell" style={{wordBreak: "break-word", whiteSpace: "pre-wrap"}}>
                                    {item.project_details?.[0]?.user_remark || ""}
                                  </div>
                                ),
                                ...(reqType === "approval"
                                  ? {}
                                  : {
                                      linkage_spoc: item.spoc_linkage_names || "",
                                    }),                               
                                linkage_spoc_remark: ['C','R']?.includes(reqStatus?.value) ? (item?.project_details[0]?.spoc_remark ) : (
                                  <ValidatingTextField 
                                    type="text"
                                    variant="outlined"
                                    size="small"
                                    name="SPOC Remark"
                                    inputProps={{
                                      "data-testid": `spoc-remark-input-${item.request_no}`,
                                    }}
                                      value={spocRemark[item.request_no] || ""}
                                      onChange={(e) =>
                                      {
                                        handleSpocRemarkChange(
                                          e.target.value,
                                          item.request_no
                                        )
                                        
                                      }
                                      }
                                  
                                      style={{ width: "100%" }}
                                      placeholder="SPOC Remark"
                                  />
                                )                   
                              }))}
                              
                              tableHeaderLabel={[
                                {
                                  label: "Select All",
                                  width: 80,
                                  component: (
                                    <div
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        gap: "5px",
                                        flexDirection:"column",
                                        whiteSpace: "nowrap",
                                      }}
                                    >
                                       <span>Select All</span>
                                      <input
                                        type="checkbox"
                                        checked={isAllSelected}
                                        ref={(checkbox) => {
                                          if (checkbox) {
                                            const checkboxRef = checkbox;
                                            checkboxRef.indeterminate = isIndeterminate;
                                          }
                                        }}
                                        onChange={handleSelectAll}
                                        style={{
                                          width: "15px",
                                          height: "15px",
                                          cursor: "pointer",
                                          margin: 0,
                                        }}
                                      />
                                     
                                    </div>
                                  ),
                                },                             
                                "Request No_100",
                                "Request Type_100",
                                "Employee Name_120",
                                "Project Details_180",
                                "Start Date_80",
                                "End Date_80",
                                "User Remark_120",
                                ...(reqType === "approval"
                                  ? []
                                  : ["Linkage SPOC_120"]),
                                "Linkage SPOC Remark_120",
                              ]}
                              TableRowHederAling="center"
                              size="small"
                              headerColor="#E6F2FF"
                              className="custom-table"
                            />
                     </div>

                            <CustomPagination
                            page={page}
                            rowsPerPage={pageSize}
                            totalRecords={filteredData.length}
                            onPageChange={(newPage) => setPage(newPage)}
                            onRowsPerPageChange={(value) => {
                              setPageSize(value);
                              setPage(1);
                            }}
                          />

                            {
                              isSame  && ( // Added for CHG0073013
                                <div style={{ display: "flex", justifyContent: "center", marginTop: "10px", gap: "10px" }}>
                          <Button
                              className={clsx(
                                styles.actionButton,
                                styles.primaryActionButton
                              )}
                              variant="primary"
                              onClick={() => handleApproveReject("A")}
                              data-testid="confirm-action"
                              disabled={selectedRows.length === 0 || selectedRows.length > 10 || reqStatus?.value === 'C' || reqStatus?.value ==='R'}
                            >
                              Approve
                            </Button>
                            <Button
                              className={clsx(styles.actionButton, styles.resetButton)}
                              variant="tertiary"
                              onClick={() => handleApproveReject("R")}
                              data-testid="confirm-action"
                              disabled={selectedRows.length === 0 || selectedRows.length > 10 || reqStatus?.value === 'C' || reqStatus?.value ==='R'}
                            >
                              Reject
                            </Button>
                          </div>
                              )
                            } {/* Added for CHG0073013 */}                         
              </>
// Changes END for CHG0073013
            ) : (
              ""
            )}
          </>
        )}
      </div>
    </div>
  );

  return (
    <div
      className={clsx(
        styles.scrollContainer,
        styles.scrollBar,
        styles.formContainer
      )}
    >
      {renderReport()}
    </div>
  );
}

export default LinkageDashboardForm;